// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"7519b80a","857":"786e3451"}[chunkId] + ".js";
};